<template lang="pug">
  .p-time-count-field(:class="rootClass" :style="rootStyle")
    .campos(v-if="decimal")
      PTextFieldLegado.input-decimal(
        v-bind="localAttributes"
        :label="label",
        type="text",
        v-model="float",
        :loading="loading",
        :disabled="disabled",
        v-on="localListeners",
        :error="error",
        placeholder="00.00"
        v-mask="['#.##', '##.##', '###.##']"
      )

    .campos(v-else)
      PTextFieldLegado.input-horas(
        v-bind="localAttributes"
        v-if="!justMinutes"
        :label="`${notShowLabel ? '' : label}`",
        type="text",
        v-model="hours",
        v-mask="['#', '##', '###']",
        :loading="loading",
        :disabled="disabled",
        v-on="localListeners",
        :error="error"
      )

      PTextFieldLegado.input-minutos(
        v-bind="localAttributes"
        :label="`${notShowLabel ? '' : labelMinutos}`",
        type="text",
        v-model="minutes",
        v-mask="withoutLimitMinutes ? ['#', '##', '###'] : mascaraDoInput",
        :loading="loading",
        :disabled="disabled",
        v-on="localListeners",
        :error="error"
      )
</template>

<script>
import { mask } from 'src/common/mask'

import PTextFieldLegado from './PTextFieldLegado.vue'
import { obterHorasMinutosParaDecimal, obterHorasEMinutosAPartirDeUmFloat } from 'src/utils/formatadoras/formatadoras'
import { handlerUseStateVmodel } from 'src/common/mixins/handlerUseStateVmodel'
import { localListenersAndAttributes } from 'src/common/mixins/localListenersAndAttributes'

function normalizarFloat (valor) {
  if (valor === undefined || valor === null || valor === '') {
    return null
  }

  const numero = typeof valor === 'number' ? valor : parseFloat(valor)
  return Number.isFinite(numero) ? numero : null
}

function valoresIniciais (estadoInicial) {
  if (!estadoInicial) {
    return {
      hours: null,
      minutes: null,
      float: null
    }
  }

  const floatNormalizado = normalizarFloat(estadoInicial.float)

  if (floatNormalizado !== null) {
    return obterHorasEMinutosAPartirDeUmFloat(floatNormalizado)
  } else if (estadoInicial.hours && estadoInicial.minutes) {
    return {
      hours: estadoInicial.hours,
      minutes: estadoInicial.minutes,
      float: obterHorasMinutosParaDecimal(estadoInicial.hours, estadoInicial.minutes)
    }
  }
}

export default {
  name: 'PTimeCountField',
  inheritAttrs: false,
  emits: ['update:modelValue', 'change'],
  props: {
    loading: {type: Boolean},
    disabled: {type: Boolean},
    decimal: {type: Boolean},
    error: {type: String},
    label: {type: String, default: 'horas'},
    labelMinutos: {type: String, default: 'minutos'},
    justMinutes: {type: Boolean, default: false},
    notShowLabel: {type: Boolean, default: false},
    withoutLimitMinutes: {type: Boolean, default: false}
  },
  created () {
    const floatNormalizado = normalizarFloat(this.state.float)

    if (floatNormalizado !== null) {
      this.float = floatNormalizado.toFixed(2)
    }
  },
  data () {
    return {
      mudancaInterna: false,
      mascaraDoInput: {
        mask: 'm#',
        tokens: {
          '#': { pattern: /\d/ },
          'm': { pattern: /[0-5]/ }
        }
      },
      ...valoresIniciais(this.modelValue)
    }
  },
  computed: {
    time: {
      get () {
        return {
          hours: this.hours,
          minutes: this.minutes,
          float: this.float
        }
      }
    }
  },
  mounted () {
    const floatNormalizado = normalizarFloat(this.state.float)

    if (floatNormalizado !== null) {
      this.updateValueWithFloat(floatNormalizado)
    }
  },
  methods: {
    updateValueWithFloat (float) {
      const floatNormalizado = normalizarFloat(float)

      if (floatNormalizado === null) {
        this.float = null
        this.hours = null
        this.minutes = null
        return
      }

      let newState
      if (this.justMinutes) {
        newState = {
          hours: 0,
          minutes: Math.floor(floatNormalizado * 60),
          float: floatNormalizado
        }
      } else {
        newState = obterHorasEMinutosAPartirDeUmFloat(floatNormalizado)
      }
      this.float = floatNormalizado.toFixed(2)
      this.hours = newState.hours
      this.minutes = newState.minutes
    }
  },
  watch: {
    state: {
      handler(novoEstado) {
        if (this.mudancaInterna) {
          this.mudancaInterna = false;
          return
        }

        const floatNormalizado = normalizarFloat(novoEstado?.float)

        if (floatNormalizado === null) {
          return
        }

        const valorDoFloatInterno = obterHorasMinutosParaDecimal(this.hours, this.minutes)

        if (Number.isFinite(valorDoFloatInterno) && floatNormalizado.toFixed(4) === valorDoFloatInterno.toFixed(4)) {
          return
        }

        this.updateValueWithFloat(floatNormalizado)
      },
      deep: true
    },
    time: function (newTime) {
      this.mudancaInterna = true

      if (this.decimal) {
        const floatNormalizado = normalizarFloat(newTime.float)

        this.state = floatNormalizado === null
          ? { hours: null, minutes: null, float: null }
          : obterHorasEMinutosAPartirDeUmFloat(floatNormalizado)
      } else {
        this.state = {
          hours: parseInt(newTime.hours),
          minutes: parseInt(newTime.minutes),
          float: obterHorasMinutosParaDecimal(newTime.hours, newTime.minutes)
        }
      }
    }
  },
  mixins: [handlerUseStateVmodel(), localListenersAndAttributes({ ignoredAttrs: ['disabled'] })],
  directives: { mask },
  components: { PTextFieldLegado }
}
</script>

<style lang="scss" scoped>
.p-time-count-field {
  .campos {
    display: flex;
    align-items: center;

    // TODO: consertar esse valores fixos de input
    .input-horas {
      width: 70px;
      margin-right: 10px;
    }

    .input-minutos {
      width: 70px;
    }

    .input-decimal {
      width: 70px;
    }
  }
}
</style>
